module.exports = __webpack_public_path__ + "img/power.0a315f71.svg";